module.exports = __webpack_public_path__ + "static/xbox-series-x-1a1a822ae5a7ffc6231519acbc792190.png";